import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface UseUrlPathDetectionReturn {
  isNegociacoesSalvasPath: boolean;
  currentPath: string;
}

/**
 * Hook to detect if the current URL path contains "negociacoes/salvas"
 * @returns Object containing path detection results
 */
export const useUrlPathDetection = (): UseUrlPathDetectionReturn => {
  const location = useLocation();

  const isNegociacoesSalvasPath = useMemo(() => {
    return location.pathname.includes('negociacoes/salvas');
  }, [location.pathname]);

  return {
    isNegociacoesSalvasPath,
    currentPath: location.pathname,
  };
};
